// extracted by mini-css-extract-plugin
export var col = "newsletter-module--col--42078";
export var fieldsWrap = "newsletter-module--fieldsWrap--1bbb9";
export var form = "newsletter-module--form--60ac4";
export var grid = "newsletter-module--grid--26ecb";
export var logo = "newsletter-module--logo--5acae";
export var message = "newsletter-module--message--cf05a";
export var newsletterTitle = "newsletter-module--newsletterTitle--68e9f";
export var root = "newsletter-module--root--aa224";